import i18next from 'i18next'
import React from 'react'
import { formatDateDDMonthYYYY } from '../../../../../utils/date'
import { Link } from '../../../../../utils/link'
import { newsTeasersBlockClasses } from '../../../../../utils/style'
import { getClassName } from '../../../../../utils/utils'
import { useInView } from '../../../../hooks/useInView'
import { InviewOptions } from '../../blocksState'
import { NewsTeaserResult } from '../../../../../backendApi/generated'

export type NewsTeasersBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  titleClassName: string
  contentClassName: string
  listClassName: string
  itemClassName: string
  linkClassName: string
  linkLabelClassName: string
  linkDateClassName: string
  linkReadMoreClassName: string
}>

export type NewsTeaser = Pick<NewsTeaserResult, 'Title' | 'AbsolutePath' | 'PublicationDate'>

type NewsTeasersBlockLayoutProps = {
  index: number
  inview?: InviewOptions
  title: string
  newsTeasers: NewsTeaser[]
}

export const NewsTeasersBlockLayout = (props: NewsTeasersBlockLayoutProps) => {
  const { index, title, inview, newsTeasers } = props
  const classes = newsTeasersBlockClasses
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("NewsTeasersBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')}
    >
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        <header className={getClassName(classes, 'headerClassName', '')}>
          {title && (
            <h2 className={getClassName(classes, 'titleClassName', 'mb-3')}>
              <span id={`${index}`} aria-hidden="true" className="block__anchor" />
              {title}
            </h2>
          )}
        </header>

        {newsTeasers.length > 0 && (
          <div className={getClassName(classes, 'contentClassName', '')}>
            <ul className={getClassName(classes, 'listClassName', '')}>
              {newsTeasers.map((item, index) => {
                // Typed as Date by the generator, but it arrives as a string: there is no jsonParseReviver
                const date = new Date(item.PublicationDate)
                return (
                  item.AbsolutePath &&
                  item.Title && (
                    <li key={index} className={getClassName(classes, 'itemClassName', '')}>
                      <Link
                        url={item.AbsolutePath}
                        title={item.Title}
                        className={getClassName(classes, 'linkClassName', '')}
                      >
                        <span className="sr-text">{i18next.t('common:publishDate')}</span>
                        <time
                          className={getClassName(classes, 'linkDateClassName', '')}
                          dateTime={date.toISOString()}
                        >
                          {formatDateDDMonthYYYY(date)}
                        </time>
                        {item.Title && (
                          <p className={getClassName(classes, 'linkLabelClassName', '')}>
                            {item.Title}
                          </p>
                        )}
                        <span
                          className={getClassName(classes, 'linkReadMoreClassName', '')}
                          aria-hidden="true"
                        >
                          {i18next.t('common:readMore')}
                        </span>
                      </Link>
                    </li>
                  )
                )
              })}
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}
